import styled from 'styled-components';

/* The clock ships at 24px for buttons and headers; beside a line of small
   text it has to come down to match the cap height. */
export const ConnectionTimingRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;

  svg {
    flex: none;
    width: 12px;
    height: 12px;
  }
`;
